'use strict'

export default Vue.component('modzpointrelais', {
    template: '#modzpointrelais-template',
    props: [
        'relais',
        'recherche',
        'pays',
        'hasErrorPointRelais',
        'erreurMessage'
    ],
    methods: {
        Back() {
            this.$emit('back')
        },
        LocaliserRelaisGeo() {
            const _self = this

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    _self.recherche.Longitude = position.coords.longitude
                    _self.recherche.Latitude = position.coords.latitude

                    _self.$emit('localiserrelaisgeo')
                })
            }
        },
        LocaliserRelaisAdresse() {
            this.$emit('localiserrelaisadresse')
        },
        ChoisirPointRelais(relai) {
            this.$emit('choisirpointrelais', relai)
        },
        ToogleHoraire(relai) {
            relai.AfficherHoraire = !relai.AfficherHoraire
            this.$forceUpdate()
        }
    }
})
